import { createMemoryHistory } from 'vue-router';

// On the storefront vue-router owns no url - the server does - so routing state lives in memory
// history and the hash is written separately. This wrapper supplies the two things that needs,
// through the RouterHistory contract instead of patching the router: hash-prefixed hrefs, and
// which of push/replace the router asked for. Going SPA means passing createWebHistory instead.
export function createHashRouterHistory() {
    const base = createMemoryHistory();
    let lastWasReplace = false;

    return Object.create(base, {
        createHref: {
            value: (path) => `#${base.createHref(path)}`,
        },
        push: {
            value: (to, data) => {
                lastWasReplace = false;
                return base.push(to, data);
            },
        },
        replace: {
            value: (to, data) => {
                lastWasReplace = true;
                return base.replace(to, data);
            },
        },
        // A traversal is the third way in, and it is a pop rather than a replace.
        go: {
            value: (delta, triggerListeners) => {
                lastWasReplace = false;
                return base.go(delta, triggerListeners);
            },
        },
        wasReplace: {
            value: () => lastWasReplace,
        },
    });
}
